import React from 'react';
import PropTypes from 'prop-types';
import { Shimmer, ShimmerElementType, Separator, mergeStyles } from '@fluentui/react';

const wrapperClass = mergeStyles({
  padding: 2,
  overflowX: 'hidden',
  selectors: {
    '& > .ms-Shimmer-container': {
      margin: '8px 0',
    },
  },
});

const titleShimmerClass = mergeStyles({
  width: 'min(320px, 80%)',
});

const messageShimmerClass = mergeStyles({
  width: 'min(520px, 95%)',
});

const shimmerWithElement1stRow = [
  { type: ShimmerElementType.line, height: 36 },
];
const shimmerWithElement2ndRow = [
  { type: ShimmerElementType.line, height: 16 },
];
const shimmerWithElement3rdRow = [
  { type: ShimmerElementType.line, height: 6 },
];
const shimmerWithElement4thRow = [
  { type: ShimmerElementType.line, height: 22 },
  { type: ShimmerElementType.gap, width: '10%' },
  { type: ShimmerElementType.line, height: 22 },
  { type: ShimmerElementType.gap, width: '10%' },
  { type: ShimmerElementType.line, height: 22 },
  { type: ShimmerElementType.gap, width: '10%' },
  { type: ShimmerElementType.line, height: 22 },
];
const shimmerWithElement5thRow = [
  { type: ShimmerElementType.line, height: 16 },
];
const shimmerWithElement6thRow = [
  { type: ShimmerElementType.line, height: 155, width: 360 },
  { type: ShimmerElementType.gap, width: 20 },
  { type: ShimmerElementType.line, height: 155, width: 360 },
];

export const DiagnosticCardShimmer = ({ responsiveSize }) => (
  <>
    <div className={wrapperClass}>
      <Shimmer shimmerElements={shimmerWithElement1stRow} className={titleShimmerClass} />
      <Shimmer shimmerElements={shimmerWithElement2ndRow} className={messageShimmerClass} />
      <Shimmer shimmerElements={shimmerWithElement3rdRow} />
      {
        responsiveSize !== 's' ? (
          <Shimmer width="70%" shimmerElements={shimmerWithElement4thRow} />
        ) : (
          <>
            <Shimmer width={170} shimmerElements={shimmerWithElement2ndRow} />
            <Shimmer width={120} shimmerElements={shimmerWithElement2ndRow} />
            <Shimmer width={200} shimmerElements={shimmerWithElement2ndRow} />
            <Shimmer width={160} shimmerElements={shimmerWithElement2ndRow} />
          </>
        )
      }
    </div>
    <Separator />
    <div className={wrapperClass}>
      <Shimmer width={180} shimmerElements={shimmerWithElement5thRow} />
      <Shimmer width={740} shimmerElements={shimmerWithElement6thRow} />
    </div>
  </>
);

DiagnosticCardShimmer.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
};
